import React from 'react';
import styled from 'styled-components';

const TimerContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const TimeDisplay = styled.span`
  font-size: 0.85rem;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.textLight};
  font-weight: 400;
`;

interface TimerProps {
  seconds: number;
}

export const Timer: React.FC<TimerProps> = ({ seconds }) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <TimerContainer>
      <TimeDisplay>
        {minutes.toString().padStart(2, '0')}:{remainingSeconds.toString().padStart(2, '0')}
      </TimeDisplay>
    </TimerContainer>
  );
};
